// 视频初剪
const keyframeRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `videoEditing/keyframe/index${i + 1}`,
  name: `videoEditing/keyframe/Index${i + 1}`,
  component: () => import(`@/views/edit/videoEditing/keyframe/index${i + 1}.vue`)
}))
const pictureRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `videoEditing/picture/index${i + 1}`,
  name: `videoEditing/picture/Index${i + 1}`,
  component: () => import(`@/views/edit/videoEditing/picture/index${i + 1}.vue`)
}))


import videoEditingIndex from '@/views/edit/videoEditing/index'



export default {
  path: '/edit',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'videoEditing/index',
        name: 'videoEditingIndex',
        component: videoEditingIndex
      },
    // 视频初剪，开始
    ...keyframeRoutes,
    ...pictureRoutes,
    // 视频初剪，结束


  ],
};
